module.exports = __webpack_public_path__ + "img/estrutura.242bb3ab.jpg";